import "./Grid.css";

export default function Grid({ children, padding, style, direction, justifyContent, alignItems, spacing }) {
    if (isNaN(padding)) padding = 0;
    if (isNaN(spacing)) spacing = 0;
    spacing = spacing * 8;

    return (
        <div
            className="yona-grid"
            style={{ 
                ...style,
                verticalAlign: "top", 
                flexDirection: direction,
                justifyContent, alignItems,
                padding: padding * 8,
                gap: spacing,
            }}
            >{children}</div>);
}